/**
 * @Author: hongwei
 * @Date: 2021-12-08 19:12:58.626
 * @Last Modified by: xinzhong
 * @Last Modified time: 2026-02-11 20:22:33
 */
export default {
    name: 'YqgHeader',

    mounted() {
        const {$refs: {header}} = this;
        this.scrollAcrossClass(header, 0, 'active');
    },

    methods: {
        scrollAcrossClass(el, breakPoint, className) {
            if (window) {
                if ((window.pageYOffset || document.scrollTop) > breakPoint) el.classList.add(className);

                window.addEventListener('scroll', () => {
                    const scrollTop = window.pageYOffset || document.scrollTop;

                    if (scrollTop > breakPoint) {
                        el.classList.add(className);

                        return;
                    }

                    el.classList.remove(className);
                });
            }
        }
    }
};
